import {Step} from 'react-joyride';
import {tourText} from '../../texts/aiHomeText';
import {stepConfig} from './aiHomeStepConfig';
import {buildSteps} from '../../utils/buildSteps';

export const getAiHomeSteps = (): Step[] =>
  buildSteps(stepConfig, tourText, 'AI Home', {autoOpenFirst: true});
